import { z } from 'zod';

export const ShowcaseKind = z.enum(['text', 'image', 'md', 'pptx']);
export type ShowcaseKind = z.infer<typeof ShowcaseKind>;

const TextPayload = z.object({ kind: z.literal('text'), body: z.string().max(20000) });
const ImagePayload = z.object({
  kind: z.literal('image'),
  r2_key: z.string(),
  alt: z.string().optional(),
});
const MdPayload = z.object({ kind: z.literal('md'), body: z.string().max(100000) });
const PptxPayload = z.object({
  kind: z.literal('pptx'),
  r2_key: z.string(),
  page_count: z.number().int().nonnegative().optional(),
});

export const ShowcasePayload = z.discriminatedUnion('kind', [
  TextPayload,
  ImagePayload,
  MdPayload,
  PptxPayload,
]);
export type ShowcasePayload = z.infer<typeof ShowcasePayload>;

export const ShowcaseItem = z.object({
  id: z.string(),
  talent_id: z.string(),
  position: z.number().int().nonnegative(),
  payload: ShowcasePayload,
  created_at: z.string(),
});
export type ShowcaseItem = z.infer<typeof ShowcaseItem>;

export const CreateShowcaseBody = z.object({
  payload: ShowcasePayload,
  position: z.number().int().nonnegative().optional(),
});
export type CreateShowcaseBody = z.infer<typeof CreateShowcaseBody>;

export const UpdateShowcaseBody = z.object({
  payload: ShowcasePayload.optional(),
  position: z.number().int().nonnegative().optional(),
});
export type UpdateShowcaseBody = z.infer<typeof UpdateShowcaseBody>;
